import React from "react";

import styles from "./HelperText.module.scss";

interface Props {
  text?: string;
}
export const HelperText = ({ text }: Props) => {
  if (!text) {
    return null;
  }

  return <span className={styles.helperText__text}>{text}</span>;
};
